<template>
  <component :is="tag" class="news-content">
    <div
      v-for="component in blok.body"
      :key="component._uid"
      class="section-inner section-contained"
    >
      <StoryblokComponent :blok="component" />
    </div>
  </component>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>
<style lang="scss" scoped>
.news-content {
  .section-inner {
    margin: 2rem 0;

    &:first-child {
      margin-top: 0;

      :deep(h2) {
        margin-top: 0;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .blok-heading {
    margin-bottom: 3rem;
  }

  :deep(h2) {
    margin-top: 3.5rem;
  }
}
</style>
